import React, {useEffect, useState} from 'react';

function Layout(props) {
    let $ = window?.jQuery;
    useEffect(() => {
    $('.project-items')?.imagesLoaded(function() {
        // Add isotope click function
        $('.project-filter .electrical')?.addClass("active");
        var selector = $('.project-filter .electrical')?.attr('data-filter');
            $(".project-items")?.isotope({
                filter: selector,
                animationOptions: {
                    duration: 750,
                    easing: 'linear',
                    queue: false,
                }
            });
        $('.project-filter li')?.on('click', function() {
            $(".project-filter li")?.removeClass("active");
            $(this)?.addClass("active");

            var selector = $(this)?.attr('data-filter');
            $(".project-items")?.isotope({
                filter: selector,
                animationOptions: {
                    duration: 750,
                    easing: 'linear',
                    queue: false,
                }
            });
            return false;
        });

        $(".project-items")?.isotope({
            itemSelector: '.single-item',
            layoutMode: 'masonry',
        });
    });
    })
  return (
    <>
    <div class="site-preloader-wrap">
            <div class="spinner"></div>
        </div>
            <div className='sticky-header'>
                 <div class="primary-header">
                <div class="container">
                    <div class="primary-header-inner">
                         <div class="header-logo" style={{bottom: 200}}>
                            <a href="/">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700070497/derma/m2lpcvjwbah5ushz1t3h.png" alt="Logo"/>
                            </a>
                        </div>
                        <div class="header-right">
                        <div class="header-menu-wrap">
                            <ul class="dl-menu">
                                <li><a href="/">Home</a>
                                    {/* <ul>
                                        <li><a href="index.html">Homepage Default</a></li>
                                        <li><a href="index-3.html">Homepage Modern</a></li>
                                        <li><a href="index-2.html">Homepage Classic</a></li>
                                        <li><a href="index-4.html">Homepage Metro</a></li>
                                    </ul> */}
                                </li>
                                <li class='dropdown_menu'><a href="#">Our Group</a>
                                    <ul>
                                        <li><a href="/aboutus">ABOUT US</a></li>
                                        <li><a href="/management">MANAGEMENT</a></li>
                                        <li><a href="/subsidiaries">SUBSIDIARIES</a></li>
                                        {/* <li><a href="company-service.html">Company Service</a></li> */}
                                    </ul>
                                </li>
                                <li><a href="/services">Services</a>
                                    {/* <ul>
                                        <li><a href="team.html">Expart Team</a></li>
                                        <li><a href="pricing.html">Pricing Plans</a></li>
                                        <li><a href="faq.html">Help &amp; FAQS</a></li>
                                        <li><a href="clients.html">Clients &amp; Partners</a></li>
                                    </ul> */}
                                </li>
                                <li><a href="/portfolio">Portfolio</a>
                                    {/* <ul>
                                        <li><a href="project-3-col.html">Projects 03 Column</a></li>
                                        <li><a href="project-4-col.html">Projects 04 Column</a></li>
                                        <li><a href="project-details.html">Projects Details</a></li>
                                    </ul> */}
                                </li>
                                <li><a href="/news&updates">News & Events</a>
                                    {/* <ul>
                                        <li><a href="blog-classic.html">Blog Classic</a></li>
                                        <li><a href="blog-grid.html">Blog Grid</a></li>
                                        <li><a href="blog-details.html">Blog Details</a></li>
                                    </ul> */}
                                </li>
                                <li><a href="/contactus">Contact Us</a></li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        <div id="dl-popup-search-box">
            <div class="box-inner-wrap d-flex align-items-center">
                <form id="form" action="#" method="get" role="search">
                    <input id="popup-search" type="text" name="s" placeholder="Type keywords here..." />
                    <button id="popup-search-button" type="submit" name="submit"><i class="fas fa-search"></i></button>
                </form>
            </div>
        </div>
    {props.children}
    <footer class="footer-section">
            <div class="footer-top">
                <div class="footer-bg">
                   <div class="truck"></div>
                   <div class="truck-2"></div>
                   <div class="truck-3"></div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 sm-padding">
                            <div class="footer-content">
                                <img class="logo" src="https://res.cloudinary.com/dedfrilse/image/upload/v1700070497/derma/w27ytgjcxdh4soglckdg.png" alt="logo" />
                                <p>Derm Group (T) Ltd <br/><br/></p>
                                <div class="footer-icon-content">
                                    <div class="footer-icon">
                                        <svg height="448pt" viewBox="0 -5 448 447" width="448pt" xmlns="http://www.w3.org/2000/svg"><path d="m448 264.5v-264h-368v56h296c4.417969 0 8 3.582031 8 8v200zm0 0"></path><path d="m178.34375 338.84375c1.5-1.5 3.535156-2.34375 5.65625-2.34375h184v-264h-368v264h72c4.417969 0 8 3.582031 8 8v92.6875zm0 0"></path></svg>
                                    </div>
                                    <div class="footer-icon-info">
                                        <h3>Need Free Consultation?</h3>
                                        <a href="#">Book Schedule?</a>
                                    </div>
                                    <ul class="footer-social">
                                        <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                        <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 sm-padding">
                            <div class="footer-content">
                                <div class="footer-header">
                                <h3>Information</h3>
                                </div>
                                <ul class="footer-list">
                                    <li><a href="#">Community</a></li>
                                    <li><a href="#">About Us</a></li>
                                    <li><a href="#">Become an affiliate</a></li>
                                    <li><a href="#">Help Center</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 sm-padding">
                            <div class="footer-content">
                                <div class="footer-header">
                                <h3>Recent Post</h3>
                                </div>
                                <ul class="thumb-post">
                                    <li>
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407509/derma/q09fpqex35ccfjlg2qlb.png" alt="post"/>
                                        <a href="blog-deatils.html">Industrial Factory Building Equipment<span>SEPTEMBER 21, 2020</span></a>
                                    </li>
                                    <li>
                                        <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700407509/derma/jku02s82pmlfmfc9jijz.png" alt="post"/>
                                        <a href="blog-deatils.html">The Evolution Of Construction<span>SEPTEMBER 21, 2020</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 sm-padding">
                            <div class="subscribe-widget">
                                <div class="sub-content">
                                    <div class="sub-icon">
                                        <svg viewBox="0 0 454.57 454.57" xmlns="http://www.w3.org/2000/svg"><path d="m452.44 156.23-65.829-46.498v-67.919c-0.66-6.728-5.843-12.128-12.539-13.061h-288.39c-6.695 0.934-11.879 6.333-12.539 13.061v67.396l-68.441 47.02c-2.711 1.968-4.428 5.021-4.702 8.359v248.16c0.89 6.811 6.25 12.172 13.061 13.061h433.63c5.747 0 7.837-6.792 7.837-13.061v-248.16c0-3.135 0.522-6.27-2.09-8.359zm-65.829-21.421 44.931 30.824-44.931 33.959v-64.783zm-292.57-85.159h271.67v166.14l-135.84 102.4-135.84-102.4v-166.14zm-20.898 84.637v65.829l-44.931-34.482 44.931-31.347zm-52.245 52.767 146.29 110.76-146.29 98.743v-209.5zm25.078 217.86 138.97-93.518 37.094 28.212c2.1 1.623 4.661 2.538 7.314 2.612 2.09 0 3.135-1.045 5.224-2.612l38.661-29.78 140.54 95.086h-367.8zm387.66-12.016-143.15-96.131 143.15-109.71v205.84z"></path><path d="m146.29 117.57h47.02c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-47.02c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449z"></path><path d="m146.29 164.59h167.18c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-167.18c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449z"></path><path d="m323.92 201.16c0-5.771-4.678-10.449-10.449-10.449h-167.18c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h167.18c5.77 0 10.448-4.678 10.448-10.449z"></path></svg>
                                    </div>
                                    <div class="footer-header">
                                        <h3>Newsletter Signup</h3>
                                    </div>
                                    <p>Stay always in touch! Subscribe to our newsletter.</p>
                                    <div class="form-field">
                                        <input type="email" name="EMAIL" placeholder="Your email address" required=""/>
                                        <input type="submit" value="Sign up" />
                                    </div>
                                    <p class="mt-15">* Don't worry, we don't spam.</p>
                                    <div class="overlay-icon">
                                        <svg viewBox="0 0 454.57 454.57" xmlns="http://www.w3.org/2000/svg"><path d="m452.44 156.23-65.829-46.498v-67.919c-0.66-6.728-5.843-12.128-12.539-13.061h-288.39c-6.695 0.934-11.879 6.333-12.539 13.061v67.396l-68.441 47.02c-2.711 1.968-4.428 5.021-4.702 8.359v248.16c0.89 6.811 6.25 12.172 13.061 13.061h433.63c5.747 0 7.837-6.792 7.837-13.061v-248.16c0-3.135 0.522-6.27-2.09-8.359zm-65.829-21.421 44.931 30.824-44.931 33.959v-64.783zm-292.57-85.159h271.67v166.14l-135.84 102.4-135.84-102.4v-166.14zm-20.898 84.637v65.829l-44.931-34.482 44.931-31.347zm-52.245 52.767 146.29 110.76-146.29 98.743v-209.5zm25.078 217.86 138.97-93.518 37.094 28.212c2.1 1.623 4.661 2.538 7.314 2.612 2.09 0 3.135-1.045 5.224-2.612l38.661-29.78 140.54 95.086h-367.8zm387.66-12.016-143.15-96.131 143.15-109.71v205.84z"></path><path d="m146.29 117.57h47.02c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-47.02c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449z"></path><path d="m146.29 164.59h167.18c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449h-167.18c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449z"></path><path d="m323.92 201.16c0-5.771-4.678-10.449-10.449-10.449h-167.18c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h167.18c5.77 0 10.448-4.678 10.448-10.449z"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom text-center">
                <div class="container">
                    <p>©️ Copyright 2023 DERM Group (T) Ltd | Designed by Essence Creative</p>
                </div>
            </div>
        </footer>
		<div id="scrollup">
            <button id="scroll-top" class="scroll-to-top"><i class="las la-arrow-up"></i></button>
        </div>
    </>
    
  )
}

export default Layout;